import Layout from 'components/Common/LayoutV2/';

export default Layout;
